import { Indicator, Root } from "@radix-ui/react-checkbox";
import { IconCheckmark2Small } from "central-icons-thick";
import type * as React from "react";

import { cn } from "@/lib/utils";

function Checkbox({ className, ...props }: React.ComponentProps<typeof Root>) {
  return (
    <Root
      className={cn(
        "peer size-4 shrink-0 rounded-checkbox border border-gray-300 bg-transparent outline-none hover:bg-gray-300 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:aria-invalid:ring-destructive/40",
        className
      )}
      data-slot="checkbox"
      {...props}
    >
      <Indicator
        className="flex items-center justify-center text-current transition-none"
        data-slot="checkbox-indicator"
      >
        <IconCheckmark2Small className="size-3.5" />
      </Indicator>
    </Root>
  );
}

export { Checkbox };
